// extracted by mini-css-extract-plugin
module.exports = {"reviewList":"_____2_Mobile3_reviewList__1avbd","review":"_____2_Mobile3_review__7TYpn"};